/* sugar:assets/collection-navigation.js@2.0.0 */
/*
 * Collection Navigation — one list of items, a free-drag Splide slider on mobile only.
 *
 * The section renders the same markup for every viewport. On mobile, when the section's
 * mobile layout is "slider", Splide mounts on the <nav> and starts on the active item so
 * the collection being viewed is in view; on desktop, and for the "wrap" layout, nothing
 * mounts and the stylesheet lays the list out as a wrapping row.
 */
(function () {
  'use strict';

  if (window.SugarCollectionNav) return;

  var MOBILE = '(max-width: 749px)';
  var RETRY_MS = 100;
  var mq = window.matchMedia(MOBILE);

  function mount(nav) {
    if (nav._splide) return true;
    if (typeof Splide === 'undefined') return false;

    var start = parseInt(nav.getAttribute('data-start') || '0', 10) || 0;
    var gap = parseInt(getComputedStyle(nav).getPropertyValue('--cn-gap'), 10) || 8;

    var instance;
    try {
      instance = new Splide(nav, {
        type: 'slide',
        drag: 'free',
        snap: false,
        autoWidth: true,
        gap: gap + 'px',
        arrows: false,
        pagination: false,
        trimSpace: true,
        focus: 'center',
        start: start,
        padding: { left: '1.5rem', right: '1.5rem' }
      });
      instance.mount();
    } catch (e) {
      return true;
    }
    nav._splide = instance;
    return true;
  }

  function unmount(nav) {
    if (!nav._splide) return;
    nav._splide.destroy(true);
    nav._splide = null;
    // destroy() leaves is-initialized / is-overflow on the root, and the vendor stylesheet
    // turns an initialized-but-inactive list into a block. Strip every state class.
    Array.prototype.slice.call(nav.classList).forEach(function (c) {
      if (c.indexOf('is-') === 0 || c.indexOf('splide--') === 0) nav.classList.remove(c);
    });
  }

  var pending = false;

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var navs = host.querySelectorAll('[data-collection-nav]');
    var ready = true;

    Array.prototype.forEach.call(navs, function (nav) {
      var wantSlider = mq.matches && nav.getAttribute('data-mobile-layout') === 'slider';
      if (wantSlider) {
        if (!mount(nav)) ready = false;
      } else {
        unmount(nav);
      }
    });

    if (!ready && !pending) {
      pending = true;
      setTimeout(function () {
        pending = false;
        init(scope);
      }, RETRY_MS);
    }
  }

  window.SugarCollectionNav = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  var onChange = function () {
    init(document);
  };
  if (mq.addEventListener) {
    mq.addEventListener('change', onChange);
  } else if (mq.addListener) {
    mq.addListener(onChange);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
